import { GoASpinner } from "@abgov/react-components";
import { useEffect, useState } from "react";
import { AppDispatch, RootState } from "../state/store";
import { useDispatch, useSelector } from "react-redux";

export interface SpinnerComponentProps {}

const useAppDispatch = () => useDispatch<AppDispatch>();
const useAppSelector: <TSelected>(
  selector: (state: RootState) => TSelected
) => TSelected = useSelector;

export const SpinnerComponent = ({}: SpinnerComponentProps) => {
  const stateSpinner = useAppSelector((state: RootState) => state.spinner);

  const [showSpinner, setShowSpinner] = useState(stateSpinner.spinner.enable);
  const [label, setLabel] = useState(stateSpinner.spinner.label);

  useEffect(() => {
    setShowSpinner(stateSpinner.spinner.enable);
    setLabel(stateSpinner.spinner.label);
  }, [stateSpinner.spinner.enable]);

  return (
    <div style={{ display: showSpinner ? "block" : "none" }}>
      <div className="spinner-overlay">
        <div className="spinner-contents">
          <GoASpinner type="infinite" size="xlarge"></GoASpinner>
          {label}
        </div>
      </div>
    </div>
  );
};
